<div class="wrapper">
  <button mat-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
    {{ 'GO_BACK' | translate }}
  </button>
</div>


